module.exports = __webpack_public_path__ + "media/images/icon_star_14-13-77060fc587ef30f2c576e0a940e30828.png";